<template>
  <div class="BSCInput">
    <span class="BSCInput-message" v-if="message !== ''"> {{ message }}</span>
    <slot></slot>

    <template v-if="typeInput !== 'textarea'">
      <input
        ref="input"
        class="BSCInput-input"
        :class="classType"
        :type="typeInput"
        :maxlength="maxlength"
        v-model="computedValue"
        :placeholder="placeholder"
        :required="required"
        v-bind="$attrs"
        @blur="$emit('blur')"
        @focus="$emit('focus')"
      />

      <div
        class="BSCInput-icon"
        :class="classType"
        v-if="typeInput === 'search'"
        @click="handleIconClick"
      >
        <BSCIcon
          v-if="isInputEmpty"
          class="BSCInput-icon-search"
          :class="classType"
          icon="closeIcon"
        />
        <BSCIcon
          v-else
          class="BSCInput-icon-search"
          :class="classType"
          icon="search"
        />
      </div>
    </template>

    <textarea
      v-else
      ref="textarea"
      class="BSCInput-textarea"
      :class="classType"
      :maxlength="maxlength"
      v-model="computedValue"
      :placeholder="placeholder"
      :required="required"
      :rows="rows"
      v-bind="$attrs"
      @blur="$emit('blur')"
      @focus="$emit('focus')"
    />
  </div>
</template>

<script>
'use strict'

export default {
  name: 'BSCInput',
  inheritAttrs: false,
  props: {
    value: {
      type: [Number, String],
      required: true
    },
    typeInput: {
      type: String,
      default: 'text'
    },
    customClass: {
      type: String,
      default: ''
    },
    maxlength: {
      type: Number,
      default: -1
    },
    placeholder: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: 'normal'
    },
    message: {
      type: String,
      default: ''
    },
    rows: {
      type: [Number, String],
      default: 2
    },
    required: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'size-8'
    }
  },
  // data() {
  //   return {
  //     updatedVal: this.value
  //   }
  // },
  computed: {
    computedValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },

    classType() {
      return [`is-${this.type}`, `is-${this.size}`, this.customClass]
    },

    isInputEmpty() {
      return this.value.length
    }
  },
  methods: {
    handleIconClick() {
      this.value.length ? (this.computedValue = '') : this.$refs.input.focus()
    }
  }
}
</script>
